import { __assign, __extends } from "tslib";
import { KinesisServiceException as __BaseException } from "./KinesisServiceException";
var InvalidArgumentException = (function (_super) {
    __extends(InvalidArgumentException, _super);
    function InvalidArgumentException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidArgumentException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidArgumentException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidArgumentException.prototype);
        return _this;
    }
    return InvalidArgumentException;
}(__BaseException));
export { InvalidArgumentException };
var LimitExceededException = (function (_super) {
    __extends(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        return _this;
    }
    return LimitExceededException;
}(__BaseException));
export { LimitExceededException };
var ResourceInUseException = (function (_super) {
    __extends(ResourceInUseException, _super);
    function ResourceInUseException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceInUseException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceInUseException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceInUseException.prototype);
        return _this;
    }
    return ResourceInUseException;
}(__BaseException));
export { ResourceInUseException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
export var ConsumerStatus;
(function (ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "ACTIVE";
    ConsumerStatus["CREATING"] = "CREATING";
    ConsumerStatus["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
export var StreamMode;
(function (StreamMode) {
    StreamMode["ON_DEMAND"] = "ON_DEMAND";
    StreamMode["PROVISIONED"] = "PROVISIONED";
})(StreamMode || (StreamMode = {}));
export var EncryptionType;
(function (EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
export var MetricsName;
(function (MetricsName) {
    MetricsName["ALL"] = "ALL";
    MetricsName["INCOMING_BYTES"] = "IncomingBytes";
    MetricsName["INCOMING_RECORDS"] = "IncomingRecords";
    MetricsName["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
    MetricsName["OUTGOING_BYTES"] = "OutgoingBytes";
    MetricsName["OUTGOING_RECORDS"] = "OutgoingRecords";
    MetricsName["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
    MetricsName["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
export var StreamStatus;
(function (StreamStatus) {
    StreamStatus["ACTIVE"] = "ACTIVE";
    StreamStatus["CREATING"] = "CREATING";
    StreamStatus["DELETING"] = "DELETING";
    StreamStatus["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
var ExpiredIteratorException = (function (_super) {
    __extends(ExpiredIteratorException, _super);
    function ExpiredIteratorException(opts) {
        var _this = _super.call(this, __assign({ name: "ExpiredIteratorException", $fault: "client" }, opts)) || this;
        _this.name = "ExpiredIteratorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ExpiredIteratorException.prototype);
        return _this;
    }
    return ExpiredIteratorException;
}(__BaseException));
export { ExpiredIteratorException };
var ExpiredNextTokenException = (function (_super) {
    __extends(ExpiredNextTokenException, _super);
    function ExpiredNextTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "ExpiredNextTokenException", $fault: "client" }, opts)) || this;
        _this.name = "ExpiredNextTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ExpiredNextTokenException.prototype);
        return _this;
    }
    return ExpiredNextTokenException;
}(__BaseException));
export { ExpiredNextTokenException };
var KMSAccessDeniedException = (function (_super) {
    __extends(KMSAccessDeniedException, _super);
    function KMSAccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSAccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "KMSAccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSAccessDeniedException.prototype);
        return _this;
    }
    return KMSAccessDeniedException;
}(__BaseException));
export { KMSAccessDeniedException };
var KMSDisabledException = (function (_super) {
    __extends(KMSDisabledException, _super);
    function KMSDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSDisabledException", $fault: "client" }, opts)) || this;
        _this.name = "KMSDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSDisabledException.prototype);
        return _this;
    }
    return KMSDisabledException;
}(__BaseException));
export { KMSDisabledException };
var KMSInvalidStateException = (function (_super) {
    __extends(KMSInvalidStateException, _super);
    function KMSInvalidStateException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSInvalidStateException", $fault: "client" }, opts)) || this;
        _this.name = "KMSInvalidStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSInvalidStateException.prototype);
        return _this;
    }
    return KMSInvalidStateException;
}(__BaseException));
export { KMSInvalidStateException };
var KMSNotFoundException = (function (_super) {
    __extends(KMSNotFoundException, _super);
    function KMSNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "KMSNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSNotFoundException.prototype);
        return _this;
    }
    return KMSNotFoundException;
}(__BaseException));
export { KMSNotFoundException };
var KMSOptInRequired = (function (_super) {
    __extends(KMSOptInRequired, _super);
    function KMSOptInRequired(opts) {
        var _this = _super.call(this, __assign({ name: "KMSOptInRequired", $fault: "client" }, opts)) || this;
        _this.name = "KMSOptInRequired";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSOptInRequired.prototype);
        return _this;
    }
    return KMSOptInRequired;
}(__BaseException));
export { KMSOptInRequired };
var KMSThrottlingException = (function (_super) {
    __extends(KMSThrottlingException, _super);
    function KMSThrottlingException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSThrottlingException", $fault: "client" }, opts)) || this;
        _this.name = "KMSThrottlingException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSThrottlingException.prototype);
        return _this;
    }
    return KMSThrottlingException;
}(__BaseException));
export { KMSThrottlingException };
var ProvisionedThroughputExceededException = (function (_super) {
    __extends(ProvisionedThroughputExceededException, _super);
    function ProvisionedThroughputExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "ProvisionedThroughputExceededException", $fault: "client" }, opts)) || this;
        _this.name = "ProvisionedThroughputExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ProvisionedThroughputExceededException.prototype);
        return _this;
    }
    return ProvisionedThroughputExceededException;
}(__BaseException));
export { ProvisionedThroughputExceededException };
export var ShardIteratorType;
(function (ShardIteratorType) {
    ShardIteratorType["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
    ShardIteratorType["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
    ShardIteratorType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardIteratorType["LATEST"] = "LATEST";
    ShardIteratorType["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
var InternalFailureException = (function (_super) {
    __extends(InternalFailureException, _super);
    function InternalFailureException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalFailureException", $fault: "server" }, opts)) || this;
        _this.name = "InternalFailureException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalFailureException.prototype);
        return _this;
    }
    return InternalFailureException;
}(__BaseException));
export { InternalFailureException };
export var ShardFilterType;
(function (ShardFilterType) {
    ShardFilterType["AFTER_SHARD_ID"] = "AFTER_SHARD_ID";
    ShardFilterType["AT_LATEST"] = "AT_LATEST";
    ShardFilterType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardFilterType["AT_TRIM_HORIZON"] = "AT_TRIM_HORIZON";
    ShardFilterType["FROM_TIMESTAMP"] = "FROM_TIMESTAMP";
    ShardFilterType["FROM_TRIM_HORIZON"] = "FROM_TRIM_HORIZON";
})(ShardFilterType || (ShardFilterType = {}));
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, __assign({ name: "ValidationException", $fault: "client" }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        return _this;
    }
    return ValidationException;
}(__BaseException));
export { ValidationException };
export var SubscribeToShardEventStream;
(function (SubscribeToShardEventStream) {
    SubscribeToShardEventStream.visit = function (value, visitor) {
        if (value.SubscribeToShardEvent !== undefined)
            return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
        if (value.ResourceNotFoundException !== undefined)
            return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ResourceInUseException !== undefined)
            return visitor.ResourceInUseException(value.ResourceInUseException);
        if (value.KMSDisabledException !== undefined)
            return visitor.KMSDisabledException(value.KMSDisabledException);
        if (value.KMSInvalidStateException !== undefined)
            return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
        if (value.KMSAccessDeniedException !== undefined)
            return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
        if (value.KMSNotFoundException !== undefined)
            return visitor.KMSNotFoundException(value.KMSNotFoundException);
        if (value.KMSOptInRequired !== undefined)
            return visitor.KMSOptInRequired(value.KMSOptInRequired);
        if (value.KMSThrottlingException !== undefined)
            return visitor.KMSThrottlingException(value.KMSThrottlingException);
        if (value.InternalFailureException !== undefined)
            return visitor.InternalFailureException(value.InternalFailureException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
export var ScalingType;
(function (ScalingType) {
    ScalingType["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
export var AddTagsToStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var HashKeyRangeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ChildShardFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConsumerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConsumerDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamModeDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DecreaseStreamRetentionPeriodInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeregisterStreamConsumerInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLimitsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLimitsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnhancedMetricsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SequenceNumberRangeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ShardFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamConsumerInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamConsumerOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamSummaryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StreamDescriptionSummaryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeStreamSummaryOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DisableEnhancedMonitoringInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnhancedMonitoringOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnableEnhancedMonitoringInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetRecordsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var _RecordFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetRecordsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetShardIteratorInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetShardIteratorOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var IncreaseStreamRetentionPeriodInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ShardFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListShardsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListShardsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamConsumersInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamConsumersOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStreamsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForStreamOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MergeShardsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordsRequestEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordsResultEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutRecordsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegisterStreamConsumerInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegisterStreamConsumerOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemoveTagsFromStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SplitShardInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartStreamEncryptionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopStreamEncryptionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartingPositionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscribeToShardInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscribeToShardEventFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscribeToShardEventStreamFilterSensitiveLog = function (obj) {
    var _a;
    if (obj.SubscribeToShardEvent !== undefined)
        return { SubscribeToShardEvent: SubscribeToShardEventFilterSensitiveLog(obj.SubscribeToShardEvent) };
    if (obj.ResourceNotFoundException !== undefined)
        return { ResourceNotFoundException: obj.ResourceNotFoundException };
    if (obj.ResourceInUseException !== undefined)
        return { ResourceInUseException: obj.ResourceInUseException };
    if (obj.KMSDisabledException !== undefined)
        return { KMSDisabledException: obj.KMSDisabledException };
    if (obj.KMSInvalidStateException !== undefined)
        return { KMSInvalidStateException: obj.KMSInvalidStateException };
    if (obj.KMSAccessDeniedException !== undefined)
        return { KMSAccessDeniedException: obj.KMSAccessDeniedException };
    if (obj.KMSNotFoundException !== undefined)
        return { KMSNotFoundException: obj.KMSNotFoundException };
    if (obj.KMSOptInRequired !== undefined)
        return { KMSOptInRequired: obj.KMSOptInRequired };
    if (obj.KMSThrottlingException !== undefined)
        return { KMSThrottlingException: obj.KMSThrottlingException };
    if (obj.InternalFailureException !== undefined)
        return { InternalFailureException: obj.InternalFailureException };
    if (obj.$unknown !== undefined)
        return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
};
export var SubscribeToShardOutputFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.EventStream && { EventStream: "STREAMING_CONTENT" }))); };
export var UpdateShardCountInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateShardCountOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateStreamModeInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
